import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import routes from './routes';
import { i18nConfig } from './locales';
import { Providers } from './providers';
import { withLayoutHOC } from './components/molecules/Layout';
import TenantName from './components/atoms/TenantName';
import IdleHandler from './components/organisms/IdleHandler';
import NetworkHandler from './components/organisms/NetworkHandler';
import ErrorHandler from './components/molecules/ErrorHandler';
import DisruptiveErrorModal from './components/molecules/DisruptiveErrorModal';
import { ProfileWrapper } from './routes/protectedRoutes';

import './styles.css';
import './roboto.css';

i18n.use(initReactI18next).init(i18nConfig);

/**
 * Root application
 *
 * @returns {JSX.Element}
 */
export default function Root({ applications, singleSpa }): JSX.Element {
    return (
        <Providers customProps={{ applications, singleSpa }}>
            <Router>
                <Switch>
                    {/** Please also update src/providers/application/index.tsx */}
                    {routes.map(({ path, exact, component }) => (
                        <Route
                            path={path}
                            component={withLayoutHOC(component)}
                            exact={exact}
                            key={path || '/'}
                        />
                    ))}
                    <Route
                        path="/:tenantId/settings/profile"
                        component={ProfileWrapper}
                    />
                </Switch>
                <Route path="/:tenantId" component={IdleHandler} />
                <Route path="/:tenantId" component={NetworkHandler} />
                <Route path="/:tenantId" component={ErrorHandler} />
                <Route path="/:tenantId" component={TenantName} />
                <Route path="/:tenantId" component={DisruptiveErrorModal} />
            </Router>
        </Providers>
    );
}
